import React from 'react'

import { AdministrationForm } from '../..'

// Queries
import { READ_TYPES, CREATE_TYPES, UPDATE_TYPES, LIST_TYPES } from './queries'

const queries = {
  read: READ_TYPES,
  create: CREATE_TYPES,
  update: UPDATE_TYPES,
  list: LIST_TYPES,
}

const AdministrationFormComponentTypes = () => (
  <AdministrationForm name={'tipo componente'} queries={queries} />
)

export default AdministrationFormComponentTypes
